function getLanguage() {
  return 'stage_language' in window
    ? window.stage_language
    : window.location.href.split('/')[3];
}

export default getLanguage;
